import { SIGNUP_PATH_IDS } from 'constants/signUp';
import { notifyError } from 'helpers/errorNotifier';

export const isFastPath = (routerQuery) => routerQuery?.utm_medium === 'pl_fastpath';

export const isAfcOktaUser = (routerQuery) => routerQuery?.utm_medium === 'afc_okta';

export const isAffiliatePartner = (routerQuery) => Boolean(routerQuery?.affiliate_partner);

export const invalidAfcOktaCredentials = (routerQuery) => routerQuery?.utm_medium === 'afc';

export const isAfcAuthFailureRedirect = (routerQuery) =>
	routerQuery?.from_afc_auth_failure === true || routerQuery?.from_afc_auth_failure === 'true';

export const hasPathId = (pathId, routerQuery) => routerQuery?.pathid === pathId;

export const isFastPathSignUp = (routerQuery) =>
	isFastPath(routerQuery) || hasPathId(SIGNUP_PATH_IDS.privateLabelPath, routerQuery);

export const parseUrl = (url) => {
	if (url) {
		try {
			return typeof url !== 'string' ? URL.createObjectURL(url[0]) : url;
		} catch (e) {
			notifyError('unable to parse file url');
		}
	}
};

export const getFileName = (file) => (file && file.length > 0 ? file[0].name : '');
